import React from 'react'
import { Form, Input, Row, Col, Select, Button, Space, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

import { registerFormRules as rules, validateNumberOfDigitsPhoneNumber } from '../../utils/form-rules';
import { phoneCompanies } from '../../data/data';

const { Option } = Select

const Phone = ({ id = 1, onDelete }) => {
    return (
        <Row gutter={10}>
            <Col xs={6} sm={4} md={4} lg={3} >
                <Form.Item
                    label="Cod. Área"
                    name={id === 1 ? 'phoneCode' : `phoneCode${id}`}
                    rules={id === 1 ? [...rules.phoneCode] : [...rules.phoneCodeX]}
                >
                    <Input addonBefore="0" maxLength={4} />
                </Form.Item>
            </Col>
            <Col xs={18} sm={20} md={10} lg={6} >
                <Form.Item
                    label="Nro de celular"
                    name={id === 1 ? 'phoneNumber' : `phoneNumber${id}`}
                    rules={id === 1 ? [...rules.phoneNumber] :
                        [
                            ...rules.phoneNumberX,
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    const phoneCode = getFieldValue(`phoneCode${id}`);
                                    const phoneNumber = value;
                                    return validateNumberOfDigitsPhoneNumber(phoneCode, phoneNumber)
                                },
                            })

                        ]}
                >
                    <Input addonBefore="15 -" maxLength={8} />
                </Form.Item>
            </Col>

            <Col xs={12} sm={24} md={10} lg={7}>
                <Form.Item
                    label="Compañia de celular"
                    name={id === 1 ? 'phoneCompany' : `phoneCompany${id}`}
                    rules={id === 1 ? [...rules.phoneCompany] : [...rules.phoneCompanyX]}
                >
                    <Select>
                        {phoneCompanies.map(c => <Option key={c.value} value={c.name} >{c.name}</Option>)}
                    </Select>
                </Form.Item>
            </Col>
            {id !== 1 &&
                <Col xs={12} sm={24} md={10} lg={7}>
                    <Space direction="vertical">
                        <label>Eliminar</label>
                        <Popconfirm
                            title="Desea eliminar el teléfono alternativo?"
                            onConfirm={() => onDelete(id)}
                            placement="rightTop"
                            okText="Si"
                            cancelText="No"
                        >
                            <Button type="primary" icon={<DeleteOutlined />} />
                        </Popconfirm>
                    </Space>
                </Col>
            }

        </Row >
    );
}

export default Phone;